// 网站配置
const Site = {
  state: {
    siteName: "吉利邮箱",
    addressToken: "", // 地址簿令牌
    // 邮件列表相关配置
    emailListConfig: {
      viewType: 0 // 视图，0：默认，1：上下结构，2：左右结构
    },
    // 当前使用语言，默认中文，与vue-i18n默认语言设为一致
    locale: "zh-cn",
    language: "origin"
  },

  // 特别注意，子模块的mutations和getters、actions都是注册在全局store上的
  mutations: {
    // 更新当前使用语言
    updataLocale(state, payload) {
      state.locale = payload
    },
    // 更新当前翻译用语言
    updataLanguage(state, payload) {
      state.language = payload
    }
  },
  getters: {}
}

export default Site



// WEBPACK FOOTER //
// ./src/store/site.js